import { useEffect, useRef } from 'react';
import { safeSessionStorage } from '@toss/storage';
import { useRouter } from 'next/router';

const SCROLL_POSITION_KEY_PREFIX = 'scroll-position:';

export const useScrollRestoration = (
  isDataReady: boolean,
  shouldRestore: boolean,
) => {
  const router = useRouter();
  const key = `${SCROLL_POSITION_KEY_PREFIX}${router.asPath}`;
  const hasRestored = useRef(false);

  useEffect(() => {
    hasRestored.current = false;
  }, [key]);

  useEffect(() => {
    if (!isDataReady || hasRestored.current) return;

    if (shouldRestore) {
      const savedY = safeSessionStorage.get(key);
      // savedY가 "0"일 수도 있으므로 null 체크 사용
      if (savedY != null) {
        const scrollY = parseInt(savedY, 10);
        if (!Number.isNaN(scrollY)) {
          requestAnimationFrame(() => {
            window.scrollTo(0, scrollY);
          });
        }
      }
    }
    hasRestored.current = true;
  }, [isDataReady, shouldRestore, key]);

  useEffect(() => {
    let ticking = false;

    const saveScroll = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        safeSessionStorage.set(key, window.scrollY.toString());
        ticking = false;
      });
    };

    window.addEventListener('scroll', saveScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', saveScroll);
    };
  }, [key]);
};
